import { render, staticRenderFns } from "./editMatchModal.vue?vue&type=template&id=61c81986&scoped=true"
import script from "./editMatchModal.vue?vue&type=script&lang=js"
export * from "./editMatchModal.vue?vue&type=script&lang=js"
import style0 from "./editMatchModal.vue?vue&type=style&index=0&id=61c81986&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c81986",
  null
  
)

export default component.exports